import { type Participant } from '@databases/presence';

import { AI_AGENT_USER } from '@canvas/model/identity';

export const getAiFieldStreamingParticipants = ({
  participants,
  shouldExcludeAiAgent
}: {
  participants: Participant[];
  shouldExcludeAiAgent: boolean;
}): Participant[] =>
  shouldExcludeAiAgent
    ? participants.filter(
        ({ identity }) => identity.accountId !== AI_AGENT_USER.accountId
      )
    : participants;
